import * as req from 'api/actions';
import * as c from './constant';

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionList = (payload = { module_type: 'DC' }, callback) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const getPhoto = (payload = {}, callback) =>
  req.item(
    c.GET_PHOTO,
    'api/v1/administrators/death_certificates/transaction_histories/photo',
    callback,
    payload
  );

export const getDeathCertificatesArchive = (payload = {}, callback) =>
  req.list(
    c.GET_DEATH_ARCHIVE,
    'api/v1/administrators/death_certificates/transaction_histories',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `api/v1/administrators/transaction_histories/death_certificates/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const updateBirthCertificate = (id, payload, callback) =>
  req.update(
    c.EDIT_BIRTH,
    `api/v1/administrators/transaction_histories/death_certificates/${id}/update_detail`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const onUpdateRegistry = (id, payload, callback) =>
  req.update(
    c.UPDATE_REGISTRY,
    `api/v1/administrators/transaction_histories/death_certificates/${id}/update_registry`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );
